import {useState} from 'react';
import {signInWithGoogle, signInWithMicrosoft} from '../../lib/ssoAuth.ts';
import FormError from '../../pages/login/FormError.tsx';

interface Props {
    onSuccess?: () => void;
    googleLabel?: string;
    microsoftLabel?: string;
}

export function SocialSignInButtons({
    onSuccess,
    googleLabel = 'Doorgaan met Google',
    microsoftLabel = 'Doorgaan met Microsoft',
}: Props) {
    const [formError, setFormError] = useState('');
    const [isSigningIn, setIsSigningIn] = useState(false);

    function startSSOSignIn(signIn: () => Promise<unknown>) {
        setIsSigningIn(true);
        setFormError('');

        signIn()
            .then(() => onSuccess?.())
            .catch((error) => {
                setFormError(error);
            })
            .finally(() => {
                setIsSigningIn(false);
            });
    }

    return (
        <div className="space-y-3">
            <button
                type="button"
                disabled={isSigningIn}
                onClick={() => startSSOSignIn(signInWithGoogle)}
                className="flex w-full items-center justify-center gap-3 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
            >
                <img src="/google.png" alt="" className="h-5 w-5" aria-hidden="true"/>
                {googleLabel}
            </button>
            <button
                type="button"
                disabled={isSigningIn}
                onClick={() => startSSOSignIn(signInWithMicrosoft)}
                className="flex w-full items-center justify-center gap-3 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
            >
                <img src="/microsoft.png" alt="" className="h-5 w-5" aria-hidden="true"/>
                {microsoftLabel}
            </button>
            {formError && <FormError message={formError}/>}
        </div>
    );
}
